<template>
    <div>
        <div class="row mt-4">
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                        Pokaż&nbsp;
                        <b-form-select v-model="perPage" :options="pageOptions" size="sm"></b-form-select>&nbsp;wierszy
                    </label>
                </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                    <label class="d-inline-flex align-items-center">
                        Szukaj:
                        <b-form-input
                            v-model="filter"
                            class="form-control form-control-sm ml-2"
                            placeholder="Szukaj..."
                            type="search"
                        />
                    </label>
                </div>
            </div>
            <!-- End search -->
        </div>
        <!-- Table -->
        <div class="table-responsive mb-0">
            <b-table
                v-if="!loading"
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="items"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                responsive="sm"
                @filtered="onFiltered"
            >
                <template v-for="slot in Object.keys($scopedSlots)" v-slot:[toCellName(slot)]="props">
                    <slot v-bind="props" :name="slot" />
                </template>
                <template #cell(options)="data">
                    <button v-if="data.value.show" class="btn btn-primary m-2" @click="showEvent(data.item)">
                        <i class="fa fa-eye"></i> Zobacz
                    </button>
                    <button v-if="data.value.edit" class="btn btn-info m-2" @click="editEvent(data.item)">
                        <i class="fa fa-edit"></i> Edytuj
                    </button>
                    <button v-if="data.value.delete" class="btn btn-danger m-2" @click="deleteEvent(data.item)">
                        <i class="fa fa-trash"></i> Usuń
                    </button>
                </template>
            </b-table>
        </div>
        <div class="row" v-if="rows > perPage || Math.ceil(rows / perPage) < currentPage">
            <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="rows"></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

export default {
    name: "DataTable",
    props: {
        fields: Array,
        items: Array,
        edit: {
            type: Boolean,
            default: false
        },
        delete: {
            type: Boolean,
            default: false
        },
        show: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            loading: true,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "id",
            sortDesc: true,
        };
    },
    computed: {
        /**
         * Total no. of records
         */
        rows() {
            return this.items.length;
        },
    },
    mounted() {
        this.totalRows = this.items.length;
        this.checkOptions();
    },
    methods: {
        checkOptions() {
            let promise;

            if (this.edit || this.delete || this.show) {
                promise = this.items.map(item => {
                    item.options = {};

                    if (this.edit)
                        item.options.edit = true;
                    if (this.delete)
                        item.options.delete = true;
                    if (this.show)
                        item.options.show = true;

                    return item;
                })
            }

            if (this.edit || this.delete || this.show) {
                this.fields.push({ key: "options", label: "Opcje"});
            }

            if (promise)
                Promise.all([promise]).then(() => {
                    this.loading = false;
                });
            else
                this.loading = false;
        },
        /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        toCellName (slot) {
            return `cell(${slot})`
        },
        editEvent(item) {
            // eslint-disable-next-line no-unused-vars
            const {options, ...onlyItem} = item;
            this.$emit("edit", onlyItem);
        },
        showEvent(item) {
            // eslint-disable-next-line no-unused-vars
            const {options, ...onlyItem} = item;
            this.$emit("show", onlyItem);
        },
        deleteEvent(item) {
            Vue.swal.fire({
                title: 'Jesteś pewny?',
                text: "Nie będziesz mógł cofnąć tej operacji!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Tak, usuń!',
                cancelButtonText: 'Anuluj'
            }).then((result) => {
                if (result.value) {

                    // eslint-disable-next-line no-unused-vars
                    const {options, ...onlyItem} = item;
                    this.$emit("delete", onlyItem);
                }
            });
        }
    },
}
</script>

<style scoped>
</style>